// Running environment
export const Environment = {
    FAKER: "FAKER",
    DEV: "DEV",
    STAGING: "STAGING",
    PROD: "PROD"
}